module.exports = __webpack_public_path__ + "img/img_kv_txt2.bc580788.png";